module.exports = __webpack_public_path__ + "img/20.656e1103.png";